const DocumentationType = {
  SWAGGER: 'swagger',
  ASYNC_API: 'asyncapi',
};

export {
  DocumentationType
};